export default "__VITE_ASSET__55e07fb8__"